export default "/images/2ab9bfc6aeb4ef63678febac827b317f.avif";